module.exports = __webpack_public_path__ + "static/media/closing-modal-editor-left.df87872f.jpg";